import React, { Fragment } from 'react';

import {
  Alert,
  Row,
  Col,
  FormGroup,
  Label,
  Button,
  Input,
  FormFeedback,
} from 'reactstrap';
import AdditionalForm from './AdditionalForm';
import CustomSelect from '../../Components/Common/CustomSelect';
import { ContactTypeList, TryingTypeList, ContactApi } from '../../Code/Data';
import { parseQuerystring } from '../../Code/Utilities';
const qsVariables = parseQuerystring(window.location.search);

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserName: '',
      CompanyName: '',
      Email: '',
      Phone: '',
      URL: '',
      ContactTypeId: '',
      Message: '',
      WasTryingTo: '',
      additionalInfo: {},
      submitted: false,
      sending: false,
      success: false,
      errMsg: null,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { currentUser } = nextProps;
    if (currentUser && prevState.LastName !== currentUser.LastName) {
      return {
        UserName: `${currentUser.FirstName} ${currentUser.LastName}`,
        CompanyName: currentUser.CompanyName || '',
        Email: currentUser.Email || '',
        Phone: currentUser.Phone || ''
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  handleChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  handleChangeContactType = ContactTypeId => this.setState({ ContactTypeId });

  handleChangeWasTrying = WasTryingTo => this.setState({ WasTryingTo });

  onAdditionalInfoChanged = additionalInfo => {
    this.setState({ additionalInfo });
  };

  formValidation() {
    const { ContactTypeId, UserName, Email, URL, Message } = this.state;
    const { currentUser } = this.props;

    if (ContactTypeId === '' || (ContactTypeId === 2 && !URL) || !Message) {
      return false;
    }
    if (!currentUser && (!UserName || !Email)) {
      return false;
    }
    return true;
  }

  submit = async () => {
    const {
      ContactTypeId,
      UserName,
      CompanyName,
      Email,
      Phone,
      URL,
      Message,
      WasTryingTo,
      additionalInfo,
    } = this.state;
    const ErrorMessage = '';
    const PurchaseId =
      WasTryingTo === 'Purchase Gift Cards' ? additionalInfo.purchaseId : null;
    const RedemptionCode =
      WasTryingTo === 'Redeem A Gift Card'
        ? additionalInfo.redemptionCode
        : null;
    const DateOfGift =
      WasTryingTo === 'Purchase Gift Cards' ||
        WasTryingTo === 'Redeem A Gift Card'
        ? additionalInfo.dateOfGift
        : null;
    const SourceOfGift =
      WasTryingTo === 'Redeem A Gift Card' ? additionalInfo.sourceOfGift : null;
    const GiftRecipientName =
      WasTryingTo === 'Purchase Gift Cards'
        ? additionalInfo.giftRecipientName
        : null;
    const DonationAmount =
      WasTryingTo === 'Purchase Gift Cards' ||
        WasTryingTo === 'Redeem A Gift Card'
        ? additionalInfo.donationAmount
        : null;
    let PageSource = qsVariables.PageSource;
    if (!PageSource) {
      if (WasTryingTo === 'Purchase Gift Cards') {
        PageSource = 'Purchase';
      } else if (WasTryingTo === 'Redeem A Gift Card') {
        PageSource = 'Redeem';
      }
    }
    this.setState({ submitted: true });
    if (this.formValidation()) {
      const data = {
        ContactTypeId,
        UserName,
        CompanyName,
        Email,
        Phone,
        URL,
        Message,
        ErrorMessage,
        WasTryingTo,
        PurchaseId,
        RedemptionCode,
        DateOfGift,
        SourceOfGift,
        GiftRecipientName,
        DonationAmount,
        PageSource: PageSource,
      };

      this.setState({ sending: true, errMsg: null, success: false });
      const response = await ContactApi(data);
      this.setState({
        sending: false,
        errMsg: response.ErrorMessage,
        success: response.Succeeded,
      });
    }
  };

  render() {
    const {
      UserName,
      CompanyName,
      Email,
      Phone,
      URL,
      ContactTypeId,
      WasTryingTo,
      Message,
      submitted,
      sending,
      success,
      errMsg,
    } = this.state;
    const { currentUser } = this.props;
    return (
      <Fragment>
        <h2>
          <u>Contact Form:</u>
        </h2>
        <Row className="mt-3">
          <Col sm={6} className="pr-sm-1">
            <FormGroup className="has-float-label">
              <Input
                name="UserName"
                id="UserName"
                placeholder="Your Name"
                invalid={submitted && !currentUser && !UserName}
                value={UserName}
                onChange={this.handleChange}
              />
              <Label for="UserName">Your Name</Label>
              <FormFeedback>Your Name is required</FormFeedback>
            </FormGroup>
          </Col>
          <Col sm={6} className="pl-sm-1">
            <FormGroup className="has-float-label">
              <Input
                name="CompanyName"
                id="CompanyName"
                placeholder="Company Name"
                value={CompanyName}
                onChange={this.handleChange}
              />
              <Label for="CompanyName">Company Name</Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={6} className="pr-sm-1">
            <FormGroup className="has-float-label">
              <Input
                name="Email"
                id="Email"
                placeholder="Your Email Address"
                invalid={submitted && !currentUser && !Email}
                value={Email}
                onChange={this.handleChange}
              />
              <Label for="Email">Your Email Address</Label>
              <FormFeedback>Your Email Address is required</FormFeedback>
            </FormGroup>
          </Col>
          <Col sm={6} className="pl-sm-1">
            <FormGroup className="has-float-label">
              <Input
                name="Phone"
                id="Phone"
                placeholder="Phone Number"
                value={Phone}
                onChange={this.handleChange}
              />
              <Label for="Phone">Phone Number</Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={6} className="pr-sm-1">
            <FormGroup className="has-float-label">
              <CustomSelect
                className={submitted && ContactTypeId === '' && 'invalid'}
                name="ContactTypeId"
                placeholder="Contact Type"
                invalid={submitted && ContactTypeId === ''}
                options={ContactTypeList}
                selectedValue={ContactTypeId}
                onChange={this.handleChangeContactType}
              />
              <FormFeedback>Contact Type is required</FormFeedback>
            </FormGroup>
          </Col>
          <Col sm={6} className="pl-sm-1">
            <FormGroup className="has-float-label">
              <CustomSelect
                name="WasTryingTo"
                placeholder="Were You Trying To?"
                options={TryingTypeList}
                selectedValue={WasTryingTo}
                onChange={this.handleChangeWasTrying}
              />
            </FormGroup>
          </Col>
        </Row>
        {ContactTypeId === 2 && (
          <FormGroup className="has-float-label">
            <Input
              name="URL"
              id="URL"
              placeholder="URL"
              invalid={submitted && !URL}
              value={URL}
              onChange={this.handleChange}
            />
            <Label for="URL">URL</Label>
            <FormFeedback>URL is required</FormFeedback>
          </FormGroup>
        )}
        <FormGroup className="has-float-label">
          <Input
            type="textarea"
            name="Message"
            id="Message"
            placeholder="Your Message"
            invalid={submitted && !Message}
            value={Message}
            onChange={this.handleChange}
          />
          <Label for="Message">Type mesage</Label>
          <FormFeedback>Message is required</FormFeedback>
        </FormGroup>

        {(WasTryingTo === 'Purchase Gift Cards' ||
          WasTryingTo === 'Redeem A Gift Card') && (
            <AdditionalForm
              type={WasTryingTo}
              onChange={this.onAdditionalInfoChanged}
            />
          )}

        <span className="w-100 text-center d-inline-block">
          <Alert
            color="success"
            isOpen={success}
            toggle={() => this.setState({ success: !success })}>
            Successfully Submitted!
          </Alert>
          <Alert
            color="danger"
            isOpen={!!errMsg}
            toggle={() => this.setState({ errMsg: null })}>
            {errMsg}
          </Alert>
          <Button color="primary" onClick={this.submit}>
            {sending ? 'Sending...' : 'Submit'}
          </Button>
        </span>
      </Fragment>
    );
  }
}